import logApiURL from "../config/logApiURL"

const SERVICE_NAME = "starset-frontend"

function getEnvironment() {
  return process.env.REACT_APP_STAGE || "local"
}

function buildContext(extra = {}) {
  const base = {
    url: typeof window !== "undefined" ? window.location.href : undefined,
    environment: getEnvironment(),
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
  }
  // Only include defined values
  return Object.fromEntries(
    Object.entries({ ...base, ...extra }).filter(([, v]) => v !== undefined)
  )
}

function sendLog(severity, message, context, stack) {
  const apiURL = logApiURL()
  if (!apiURL) return

  const logEntry = {
    severity,
    message,
    ...(stack ? { stack } : {}),
    ...(context && Object.keys(context).length > 0 ? { context } : {}),
  }

  fetch(`${apiURL}/logs`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ serviceName: SERVICE_NAME, logs: [logEntry] }),
  }).catch(() => {
    // Silently fail — logging must never break the app
  })
}

function log(severity, messageOrError, secondArg) {
  let message
  let stack
  let context

  if (messageOrError instanceof Error) {
    message = messageOrError.message
    stack = messageOrError.stack
    context = buildContext({ errorType: messageOrError.name })
  } else {
    message = String(messageOrError)
    if (secondArg instanceof Error) {
      stack = secondArg.stack
      context = buildContext({ errorType: secondArg.name })
    } else if (secondArg && typeof secondArg === "object") {
      context = buildContext(secondArg)
    } else {
      context = buildContext()
    }
  }

  if (getEnvironment() !== "prod") {
    const fn =
      severity === "ERROR" || severity === "CRITICAL"
        ? console.error
        : severity === "WARNING"
        ? console.warn
        : console.log
    fn(`[${severity}]`, message, ...(secondArg !== undefined ? [secondArg] : []))
  }

  sendLog(severity, message, context, stack)
}

const logger = {
  debug: (message, context) => log("DEBUG", message, context),
  info: (message, context) => log("INFO", message, context),
  warn: (message, context) => log("WARNING", message, context),
  error: (message, errorOrContext) => log("ERROR", message, errorOrContext),
  critical: (message, errorOrContext) => log("CRITICAL", message, errorOrContext),
}

export default logger
